<template>
    <div class="card shadow-lg">
        <slot>
            <!-- <div class="card-header bg-transparent" :style="style"></div> -->
            <div v-if="slots.header" class="card-header" :class="headerClasses">
                <slot name="header"></slot>
            </div>
            <div
                class="card-body"
                :class="[
                    cardBody,
                    {
                        'overflow-auto': scrollable,
                    },
                ]"
            >
                <slot name="body"></slot>
            </div>
            <div v-if="slots.footer" class="card-footer" :class="footerClasses">
                <slot name="footer"></slot>
            </div>
        </slot>
    </div>
</template>
<script setup lang="ts">
import { useSlots } from 'vue';
const props = defineProps({
    rounded: {
        type: Boolean,
        default: false,
    },
    noPadding: {
        type: Boolean,
        default: false,
        required: false,
    },
    headerClasses: {
        type: String,
        required: false,
        default: 'bg-transparent',
    },
    footerClasses: {
        type: String,
        required: false,
        default: 'd-flex justify-content-end gap-2',
    },
    cardBody: {
        type: String,
        required: false,
    },
    scrollable: {
        type: Boolean,
        default: false,
    },
});

const slots = useSlots();
</script>
